
import { defineComponent } from "vue";
import { ContentLoader } from "vue-content-loader";
import { MdCard } from "../md/MdCard";

export default defineComponent({
  name: "ChatbotCardLoader",
  components: { ContentLoader, MdCard },
});
